<template>
    <div class="startdesk"
         v-bind:class="{ 'is-selected' : isSelected }"
         v-on:click="selectable ? toggleSelect : null"
         v-on:contextmenu.prevent.stop="handleRightClick($event)"

    >
        <div v-bind:class="{ 'is-drop-active' : dropActive }"
             v-bind:draggable="draggable"
             v-on="draggable ? { drop : handleReorder, dragdrop: handleReorder, dragleave: handleDragLeave, dragover: handleDragOver } : {}"
             v-on:dragstart="setDragIcon"
        >
            <span class="startdesk__name">{{ startdesk.name }}</span>

            <span class="startdesk__actions" v-if="showActions">
                <a class="startdesk__action tile__action--select" href="javascript: void(0);"
                   v-if="showSelectAction"
                   v-on:click.prevent="toggleSelect"
                >
                    <span class="jam jam-check"></span>
                </a>
                <a class="startdesk__action startdesk__action--screenshot"
                   v-on:click.prevent="handleScreenshotStartdesk()"
                   v-if="user && user.is_admin"
                >
                    <span class="jam jam-camera"></span>
                </a>
                <a class="startdesk__action startdesk__action--view"
                   v-on:click.prevent="handleViewStartdesk()"
                >
                    <span class="jam jam-eye"></span>
                </a>
                <router-link class="startdesk__action startdesk__action--edit"
                             v-bind:to="{ name: 'startdesks.edit', params: { startdesk: startdesk.id } }"
                >
                    <span class="jam jam-pencil"></span>
                </router-link>
                <a class="startdesk__action startdesk__action--delete" href="javascript: void(0);"
                   v-on:click.prevent="openDeleteConfirmModal('delete-startdesk-' + startdesk.id)"
                >
                    <span class="jam jam-close"></span>
                </a>
            </span>
            
            <a v-on:click.prevent="handleViewStartdesk()">
                <div class="startdesk__screenshot" v-bind:style="backgroundProperty"></div>
            </a>
            
            <div class="startdesk__columns">
                <button class="btn is-primary startdesk__add-btn" type="button"
                        v-if="showAddToMyStartdesksButton"
                        v-on:click="handleAddToMyStartdesks"
                >
                    {{ __('Add to my startdesks') }}
                </button>

                <toggle v-bind:click="toggleVisibleToUser"
                        v-bind:label="__('Show in menu?')"
                        v-if="showActions && !user.is_admin"
                        v-model="isVisibleToUser"
                />

                <toggle v-bind:click="togglePrivate"
                        v-bind:label="__('Is public?')"
                        v-if="showActions && !user.is_admin"
                        v-model="isPublic"
                />

                <toggle v-bind:click="toggleDefault"
                        v-bind:label="__('Is default?')"
                        v-if="showActions && user.is_admin"
                        v-model="isDefault"

                />

                <toggle v-bind:click="toggleActiveAdmin"
                        v-bind:label="__('Active admin?')"
                        v-if="showActions && user.is_admin"
                        v-model="isActiveAdmin"
                />

                <toggle v-bind:click="toggleVisibleToUser"
                        v-bind:label="__('Visible to users?')"
                        v-if="showActions && user.is_admin"
                        v-model="isVisibleToUser"
                />

                <div class="startdesk__data" v-if="user.is_admin && showData">
                    <span class="startdesk__data--created-at">Created at:<br /> <span>{{ startdesk.created_at }}</span></span>
                </div>
                <div class="startdesk__data" v-if="user.is_admin && showData">
                    <span class="startdesk__data--updated-at">Updated at:<br /> <span>{{ startdesk.updated_at }}</span></span>
                </div>
            </div>

            <div class="startdesk__data" v-if="user.is_admin && showData">

                <div class="startdesk__data--category">
                    Owner:
                    <a v-on:click.prevent="handleClickOwner(startdesk.user.name)"><span>{{ startdesk.user.name }}</span></a>
                </div>
                <div class="startdesk__data--category">
                    Category:
                    <div class="is-inline-block" v-for="(category_item, index) in startdesk.category_hierarchy">
                        {{ index > 0 ? '&nbsp;/&nbsp;' : '' }}
                        <a v-on:click.prevent="handleClickCategory(category_item)"><span>{{ category_item ? category_item.name : '' }}</span></a>
                    </div>
                </div>
                <div class="startdesk__data--url">
                    URL:
                    <a v-on:click.prevent="handleViewStartdesk()"><span>{{ this.appUrl + '/' + (startdesk.is_user_startdesk ? 'u/': '' ) + startdesk.slug }}</span></a>
                </div>
            </div>
        </div>

        <confirm-modal
                v-bind:id="'delete-startdesk-' + startdesk.id"
                v-bind:text="__('Are you sure you wish to delete this startdesk?')"
        ></confirm-modal>

        <context-menu
                v-bind:elementId="'startdeskContextMenu' + startdesk.id"
                v-bind:options="contextMenuOptions"
                v-bind:ref="'contextMenu' + startdesk.id"
                v-if="showActions"
                v-on:optionClicked="handleContextMenuClick"
        ></context-menu>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import confirmModal from '../elements/ConfirmModal.vue';
    import contextMenu from '../elements/ContextMenu.vue';
    import tile from './Tile.vue';
    import toggle from '../elements//Toggle';

    export default {
        components: {
            confirmModal,
            contextMenu,
            tile,
            toggle
        },
        computed: {
            backgroundProperty: function () {
                return 'background-image: url(' + this.appUrl + '/media/startdesks/' + this.startdesk.share_image + '?v=' + this.startdesk.updated_at.replace(' ', '-').replace(/:/g, '-') + this.forceIt + ')';
            },
            eventHandlerProperty: function () {
                let obj = {};

                if (this.draggable) {
                    obj.dragend = this.handleReorder;
                }
                if (this.selectable) {
                    obj.click = this.toggleSelect;
                }

                return obj;
            }
        },
        created: function () {
            // attach event listeners
            eventBus.$on('confirm', this.handleDelete);
            eventBus.$on('deselect-all-startdesks', this.deselect);
            eventBus.$on('select-all-startdesks', this.select);
        },
        data: function () {
            return {
                contextMenuOptions: [
                    {
                        name: 'Edit',
                        slug: 'edit'
                    },
                    {
                        name: 'Delete',
                        slug: 'delete'
                    }
                ],
                dropActive: false,
                isActiveAdmin: true,
                isDefault: true,
                isPublic: true,
                isSelected: false,
                isVisibleToUser: true,
                tiles: [],
                forceIt: 0
            }
        },
        methods: {
            deselect: function () {
                if (this.isSelected == true) {
                    this.isSelected = false;

                    this.$parent.selectedStartdesks = this.$parent.selectedStartdesks.filter(function (startdesk) {
                        return this.startdesk != startdesk;
                    }.bind(this));
                }
            },
            handleAddToMyStartdesks: function (e) {
                eventBus.$emit('show-loader');

                this.select();
                this.$parent.handleAdd();

                eventBus.$emit('hide-loader');
            },
            handleClickCategory: function (category) {
                eventBus.$emit('show-loader');

                this.$parent.updateCategory(category.id);

                eventBus.$emit('hide-loader');
            },
            handleClickOwner: function (owner) {
                eventBus.$emit('show-loader');

                this.$parent.searchByOwner = owner;
                this.$parent.getStartdesks();

                eventBus.$emit('hide-loader');
            },
            handleContextMenuClick: function(event) {
                if (event.option.slug == 'edit') {
                    this.$router.push({
                        name: 'startdesks.edit',
                        params: { startdesk: event.item.id }
                    });
                } else if (event.option.slug == 'delete') {
                    this.openDeleteConfirmModal('delete-startdesk-' + event.item.id)
                }
            },
            handleDragLeave: function(event) {
                this.dropActive = false;
                event.preventDefault();
            },
            handleDragOver: function(event) {
                this.dropActive = true;
                event.preventDefault();
            },
            handleReorder: function(event) {
                this.dropActive = false;

                const id = event.dataTransfer.getData('text');

                this.$parent.handleReorder(id, this.startdesk.id);
            },
            handleRightClick: function(event) {
                if (this.showActions) {
                    this.$refs['contextMenu' + this.startdesk.id].showMenu(event, this.startdesk);
                }
            },
            handleDelete: function (id) {
                if (
                    id == 'delete-startdesk-' + this.startdesk.id
                    || (
                        id == 'delete-selected-startdesks'
                        && this.$parent.selectedStartdesks.indexOf(this.startdesk) !== -1
                    )
                ) {
                    eventBus.$emit('show-loader');

                    this.$http.delete(this.apiUrl + '/startdesks/' + this.startdesk.id).then(function (response) {
                        if (this.$parent.paging) {
                            this.$parent.paging.to--;
                            this.$parent.paging.total--;

                            this.$parent.selectedStartdesks = this.$parent.selectedStartdesks.filter(function (startdesk) {
                                return this.startdesk != startdesk;
                            }.bind(this));

                            this.$parent.startdesks = this.$parent.startdesks.filter(function (startdesk) {
                                return this.startdesk.id != startdesk.id
                            }.bind(this));
                        } else {
                            this.$parent.getStartdesks();
                        }

                        const startdesks = this.myStartdesks.filter(function (startdesk) {
                            return startdesk.id != this.startdesk.id
                        }.bind(this));

                        this.updateStartdesks(startdesks);

                        if (this.startdesk.id == this.activeStartdesk.id) {
                            if (this.myStartdesks.length > 0) {
                                this.changeStartdesk(this.myStartdesks[0]);
                            } else {
                                this.changeStartdesk(null);
                            }
                        }

                        eventBus.$emit('hide-loader');
                    }.bind(this), function (response) {
                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors sending data to server.')
                        );

                        eventBus.$emit('hide-loader');
                    });
                }
            },
            handleViewStartdesk: function() {
                this.viewStartdesk(this.startdesk);

                this.$router.push({
                    name: 'startdesks.view',
                    params: { startdesk: this.startdesk.slug, u: this.startdesk.is_user_startdesk }
                });


            },
            init: function () {
                this.isActiveAdmin = !!this.startdesk.is_active_admin;
                this.isVisibleToUser = !!this.startdesk.is_visible_to_user;
                this.isPublic = !this.startdesk.is_private;
                this.isDefault = !!this.startdesk.is_default;
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            setDragIcon: function (event) {
                event.stopPropagation();

                const el = event.currentTarget;

                event.dataTransfer.setData('text/plain', this.startdesk.id);
                event.dataTransfer.setDragImage(el, 10, 10);
            },
            select: function () {
                if (this.isSelected == false) {
                    this.isSelected = true;

                    this.$parent.selectedStartdesks.push(this.startdesk);
                }
            },
            toggleActiveAdmin: function () {
                eventBus.$emit('show-loader');

                this.$http.patch(this.apiUrl + '/startdesks/' + this.startdesk.id, {
                    is_active_admin: !this.isActiveAdmin
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    this.isActiveAdmin = response.body.is_active_admin;
                    this.getStartdesks();

                    eventBus.$emit(
                        'show-alert',
                        'success',
                        this.__('Startdesk status has been successfully changed.')
                    );
                }.bind(this), function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors sending data to server.')
                    );
                }.bind(this));

            },
            toggleDefault: function () {
                eventBus.$emit('show-loader');

                this.$http.patch(this.apiUrl + '/startdesks/' + this.startdesk.id, {
                    is_default: !this.isDefault
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    this.isDefault = response.body.is_default;

                    eventBus.$emit(
                        'show-alert',
                        'success',
                        this.__('Startdesk status has been successfully changed.')
                    );
                }, function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors sending data to server.')
                    );
                });

            },
            togglePrivate: function () {
                eventBus.$emit('show-loader');

                this.$http.patch(this.apiUrl + '/startdesks/' + this.startdesk.id, {
                    is_private: this.isPublic
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    this.isPublic = !response.body.is_private;

                    this.getStartdesks();

                    eventBus.$emit(
                            'show-alert',
                            'success',
                            this.__('Startdesk status has been successfully changed.')
                    );
                }.bind(this), function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors sending data to server.')
                    );
                });

            },
            toggleVisibleToUser: function () {
                eventBus.$emit('show-loader');

                this.$http.patch(this.apiUrl + '/startdesks/' + this.startdesk.id, {
                    is_visible_to_user: !this.isVisibleToUser
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    this.isVisibleToUser = response.body.is_visible_to_user;

                    this.getStartdesks();

                    eventBus.$emit(
                        'show-alert',
                        'success',
                        this.__('Startdesk status has been successfully changed.')
                    );
                }.bind(this), function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors sending data to server.')
                    );
                });

            },
            toggleSelect: function () {
                this.isSelected = !this.isSelected;

                if (this.isSelected) {
                    this.$parent.selectedStartdesks.push(this.startdesk);
                } else {
                    this.$parent.selectedStartdesks = this.$parent.selectedStartdesks.filter(function (startdesk) {
                        return this.startdesk != startdesk;
                    }.bind(this));
                }
            },
            handleScreenshotStartdesk: function () {
                eventBus.$emit('show-loader');

                this.$http.post(this.apiUrl + '/startdesks/' + this.startdesk.id + '/screenshot', {
                }).then(function (response) {
                    eventBus.$emit('hide-loader');
                    
                    this.forceIt = Math.random();
                    this.startdesk.share_image = this.startdesk.slug + '.png';

                    eventBus.$emit(
                        'show-alert',
                        'success',
                        this.__('Startdesk screenshot has been successfully generated.')
                    );
                }.bind(this), function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors sending data to server.')
                    );
                }.bind(this));

            }
        },
        mounted: function () {
            this.init();
            this.forceIt++;
        },
        props: {
            draggable: {
                default: false,
                type: Boolean
            },
            selectable: {
                default: false,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            },
            showAddToMyStartdesksButton: {
                default: false,
                type: Boolean
            },
            showData: {
                default: true,
                type: Boolean
            },
            showSelectAction: {
                default: false,
                type: Boolean
            },
            startdesk: {
                required: true,
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Startdesk.vue